export default __webpack_public_path__ + "static/media/Hobbies.2e369c90.webp";